import { useState } from "react";

import { Button } from "react-bootstrap";
import { Controller, useController, UseControllerProps } from "react-hook-form";

import AsyncSelect from "react-select/async";
import { v4 as uuidv4 } from "uuid";

import { ErrorForm } from "./ErrorForm.tsx";
import Input from "./Input";
import { LabelForm, LabelFormProps } from "./LabelForm.tsx";
import FetchAddress from "../../../_helpers/axiosGouvHelper";




type SearchAddressProps = {
  isDisabled: boolean;
  defaultAddress?: string;
  onChangeCallback?: (selectedValue: any) => void;
} & UseControllerProps &
  LabelFormProps;

const SearchAddress = ({
  label,
  labelInfos,
  isDisabled,
  control,
  name,
  rules,
  defaultAddress,
  onChangeCallback,
}: SearchAddressProps) => {
  const [isAddressManual, setIsAddressManual] = useState(false);
  const { field } = useController({ name, control });

  const loadOptionsHandler = (
    inputText: string,
    callback: (options: any) => void
  ): void => {
    FetchAddress.get(`search/?q=${inputText.replace(/ /g, "+")}`).then(
      (response: any) => {
        const data = response.data.features;
        callback(
          data.map(
            (result: {
              properties: { city: any; name: any; label: any; postcode: any };
              geometry: { coordinates: { toString: () => any }[] };
            }) => {
              return {
                value: {
                  city: result.properties.city,
                  address: result.properties.name,
                  zip: result.properties.postcode,
                  longitudeX: result.geometry.coordinates[0].toString(),
                  latitudeY: result.geometry.coordinates[1].toString(),
                  id: uuidv4(),
                },
                label: result.properties.label,
              };
            }
          )
        );
      }
    );
  };

  return (
    <div className="form-input">
      <div className={"d-flex gap-3 align-items-center flex-wrap h-100"}>
        <>
          {!isAddressManual ? (
            <Controller
              control={control}
              name={name}
              rules={{
                ...rules,
              }}
              render={({ field, fieldState }) => {
                return (
                  <div className="form-input flex-grow-1">
                    <LabelForm
                      label={label}
                      labelInfos={labelInfos}
                      required={!!rules?.required}
                    />
                    <div
                      className={`custom-async-select ${
                        isDisabled ? "disabled" : ""
                      }`}
                    >
                      <AsyncSelect
                        isDisabled={isAddressManual}
                        defaultInputValue={
                          field?.value &&
                          field.value.address &&
                          field.value.zip &&
                          field.value.city
                            ? `${field.value.address} ${field.value.zip} ${field.value.city}`
                            : defaultAddress || ""
                        }
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: fieldState.error ? "red" : "grey",
                          }),
                        }}
                        cacheOptions
                        loadOptions={loadOptionsHandler}
                        placeholder={""}
                        noOptionsMessage={() => "Aucune adresse correspondante"}
                        loadingMessage={() => "Recherche..."}
                        onChange={(value: any) => {
                          field.onChange(value.value);
                          if (onChangeCallback) {
                            onChangeCallback(value.value);
                          }
                        }}
                      />
                      <ErrorForm error={fieldState.error} />
                    </div>
                  </div>
                );
              }}
            />
          ) : (
            <>
              <div className="flex-grow-1">
                <Input
                  label="Adresse :"
                  rules={{ required: "L'adresse est requis" }}
                  name={name + ".address"}
                  control={control}
                />
              </div>
              <div className="flex-grow-1">
                <Input
                  label="Ville :"
                  rules={{ required: "La ville est requis" }}
                  name={name + ".city"}
                  control={control}
                />
              </div>
              <div className="flex-grow-1">
                <Input
                  label="Code postal :"
                  rules={{ required: "Le code postal est requis" }}
                  name={name + ".zip"}
                  control={control}
                />
              </div>
            </>
          )}
          {!onChangeCallback ? (
            <div
              className="d-flex align-items-center mt-1"
            >
              <Button
                onClick={() => {
                  const manualAddress = {
                    city: field.value?.city || "",
                    address: field.value?.address || "",
                    zip: field.value?.zip || "",
                    longitudeX: field.value?.longitudeX || "",
                    latitudeY: field.value?.latitudeY || "",
                    id: uuidv4(),
                  };
                  console.log("Manual address:", manualAddress);
                  field.onChange(manualAddress);
                  setIsAddressManual(!isAddressManual);
                }}
                variant="outline-primary"
                type="button"
              >
                {isAddressManual ? "Annuler" : "Saisir manuellement"}
              </Button>
            </div>
          ) : null}
        </>
      </div>
    </div>
  );
};

export default SearchAddress;
